// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"6fa577b0","522":"fb653a36","545":"41c39316","551":"a22a53b6","605":"dd6279ae","662":"2711b757"}[chunkId] + ".chunk.js";
};